export const cannotCreateToast = {
  title: '您無權限建立此追蹤工具',
  title_auto: '您無權限建立任何追蹤工具，請聯繫店長開啟編輯權限',
};
